import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Inject, Input, OnChanges, OnInit, Output, QueryList, Renderer2, SecurityContext, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { AgendaTaskEditDialogComponent } from '../agenda-task-edit-dialog/agenda-task-edit-dialog.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { MinutesCollabDetails, MeetingResponse, agendaList } from 'src/app/models/basicMeetingModel';
import { FreeFormAgendaService } from 'src/app/service/free-form-agenda.service';
import { DomSanitizer } from '@angular/platform-browser';
// import * as $ from 'jquery';
import $ from 'jquery';

import { Popover } from 'bootstrap';
import { UtilityService } from 'src/app/service/utility.service';
import { FreeFormMinutesService } from 'src/app/service/free-form-minutes.service';
import { AttachmentService } from 'src/app/service/attachment.service';
import { AttachmentDialogComponent } from '../attachment-dialog/attachment-dialog.component';
import { AgendaEditDialogComponent } from '../agenda-edit-dialog/agenda-edit-dialog.component';
import { PredefinedNotesFieldComponent } from '../dialog-predefined-notes/predefined-notes-field.component';
import { AgendaNotesFieldComponent } from '../dialog-notes-field/agenda-notes-field.component';
import { AddLinkDialogComponent } from '../add-link-dialog/add-link-dialog.component';
import { MeetingService } from 'src/app/service/meeting.service';
import { CdTimerComponent } from 'angular-cd-timer';
import { TimerComponent } from '../timer/timer.component';
import { WebsocketTransferService } from 'src/app/service/websocket-transfer.service';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { PermissionService } from 'src/app/service/permission.service';
import { Globals } from 'src/app/service/global';
import { environment_const, meetingTourValues, scheduleMeetingTourValues, pastMeetingTourValues } from 'src/environments/environment';
import { DOCUMENT } from '@angular/common';
import { log } from 'console';

declare let CKEDITOR: any;
@Component({
  selector: 'app-instant-meeting-agenda',
  templateUrl: './instant-meeting-agenda.component.html',
  styleUrls: ['./instant-meeting-agenda.component.css'],
})
export class InstantMeetingAgendaComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() timerTrackerArray: number[] = [];
  @Output() updateTimerTracker = new EventEmitter<number[]>();
  @Output() viewPreviousAgenda = new EventEmitter<any>()
  matDialogRef!: MatDialogRef<AttachmentDialogComponent>;
  @Input()
  meetingResponse !: MeetingResponse;
  // @Input('agList') agList:any;
  meetingStarted = false;
  agendaAttachResp: any;
  attachmentTotalCnt :any =true;
  loggedInUser = localStorage.getItem("userId");
  @ViewChild('TimerComponent') timerTrigger!: TimerComponent;
  @ViewChildren('minuteItem') minuteItems!: QueryList<ElementRef>;
  attachmentCount: any;
  attachmentResp: any;
  responsevalue: any;
  attachmentIcon = 'Y';
  @Input() pinDialogTriggered = false
  @Input() contentEditableBool : any
  @Input() level: number = 0;
  @Input() indexNumber: number = 0;
  @Output() subAgendaEventEmitter=new EventEmitter<MeetingResponse>()
  @Input('inFullscreen') inFullscreen: boolean = false;
  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.XSmall
    );
    isMedium: Observable<BreakpointState> = this.breakpointObserver.observe(
      Breakpoints.Medium
    )
    isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
      Breakpoints.Small
    )
  draggedId: any;
  draggedEntityType: any;
  draggedObj: any;
  meetingTourValues = meetingTourValues;
  scheduleMeetingTourValues = scheduleMeetingTourValues;
  pastMeetingTourValues = pastMeetingTourValues;
  videoSectionStatusChecker = true;
  disableAgendaIcon: any;
  editCollabData = <MinutesCollabDetails>{};

  @ViewChild('element') agendaRights!: ElementRef;
  selectedTabName: any;
  lengthForMinutes: void | undefined;
  minutesLengthChecker: void | undefined;
  currentDurationVal: any;
  previewsAgendaEditIcons: any;
  disaleAttachmentFileIcon: any;
  dropTargetIds: any = [];
  nodeLookup: any = {};
  dropTargetMinIds: any = [];
  minLookup: any = {};
  nodes: any;

  //@Output() isTaskUpdated : any = new EventEmitter();
  constructor(@Inject(DOCUMENT) private document: Document, private permissionService:PermissionService,public globals:Globals, public sideNavService: SideNavServiceService, private readonly breakpointObserver: BreakpointObserver,public meetingService: MeetingService, private webTranService:WebsocketTransferService,private dialog: MatDialog, public commonService: FreeFormAgendaService, public domSanitizer: DomSanitizer, public utilService: UtilityService, public commonMinService: FreeFormMinutesService, public attachService: AttachmentService, private cd: ChangeDetectorRef) {
    commonService.agendaRes.subscribe((req: any) => {
      // this.trackMeetingResponse();
    });
  }
  ngAfterViewInit(): void {
    
    
    setTimeout(() => {

      const roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utilService.featureList.AGENDA,this.utilService.permissionType.MODIFY);
      if(!roleFlag){
        this.selectedTabName = roleFlag;
        this.disableAgendaIcon = true;
      }

    }, 1000);
    //throw new Error('Method not implemented.');
    this.minuteItems.changes.subscribe((list: QueryList<ElementRef>) => {
      if (list.length) {
      if(this.meetingResponse.commonMomStatusCode!=undefined && this.meetingResponse.commonMomStatusCode==environment_const.momApproveStatus){
        this.sideNavService.disablePageAfterApproval();
      }else{
        this.sideNavService.enableAfterApproveToNormal();
      }      }
    });
 
    // Also handle initial load
    if (this.minuteItems.length) {
      
      if(this.meetingResponse.commonMomStatusCode!=undefined && this.meetingResponse.commonMomStatusCode==environment_const.momApproveStatus){
        this.sideNavService.disablePageAfterApproval();
      }else{
        this.sideNavService.enableAfterApproveToNormal();
      }    }
  }
 

  options: any
  attachCount: boolean = true;
  today: any
  currentDate: any
  popoverHtmlStr: any;
  popoverSafeHtml: any;
  showTimer = false;
  expansion = true
  secondExpansion = false;

  dropActionTodo: any = null;

  //UI Change
  dragPositionIndex : any
  showTimerFunc(obj: any) {
     var id=obj.agendaId;
    const roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utilService.featureList.AGENDA,this.utilService.permissionType.MODIFY);
    
    if(!roleFlag){
      return;
    }

    $('#clockIcon'+id).attr('disabled','true')
    $('#clockIcon'+id).addClass('disable-clock-class')

    document.getElementById('startTimer'+id)?.click()

    if(this.instantMeetingStarted == true){
      this.meetingStarted = true;
      this.timerTrackerArray.push(id)
      if(this.timerTrackerArray.length != 0){
        for(let i  = 0; i < this.timerTrackerArray.length - 1; i++ ){
          const pauseTimer = document.getElementById('pauseTimer'+this.timerTrackerArray[i]);
          const playTimer = document.getElementById('playTimer'+this.timerTrackerArray[i]);
          if(pauseTimer != null){
            pauseTimer.click()
          }

        }

      }
      
       const timer = (<HTMLElement>document.getElementById('timer'+id));
      
    }
    
    // $('#timer'+id).css("display", "block")
     $('timer'+id).attr('hidden','false')
    this.commonService.collapAgendaList(obj,'start');
    this.updateTimerTracker.emit(this.timerTrackerArray);
  }
  ngOnInit(): void {
    
    this.options = {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    }
    this.nodes = this.meetingResponse.agendaList;
    this.today = new Date();
    this.currentDate = this.today.toLocaleDateString("en-US", this.options)
    const tempInt = setInterval(() => {
       
      if(this.meetingResponse!=undefined){
        var agendaList = this.meetingResponse.agendaList;
        if (agendaList != null) {
          this.prepareDragDrop(this.meetingResponse.agendaList);
          clearInterval(tempInt);
          agendaList.forEach((ag: any) => {
            this.attachmentCount = ag.attachmentFileCount + ag.attachmentLinkCount;
            if(ag.agendaFlag=='START')
            document.getElementById('clockIcon'+ag.agendaId)?.click();
            
            

          });
        }
      }
     },500);
    if(this.sideNavService.openInstantMeetingTransmitter()){
      this.videoSectionStatusChecker = false
    }
    else{
      this.videoSectionStatusChecker = true
    }
  }

  ngAfterViewChecked(){
    if(this.sideNavService.openInstantMeetingTransmitter()){
      this.videoSectionStatusChecker = this.sideNavService.getVideoPaneOpenCloseStatus()
    }
  }

  prepareDragDrop(nodes: any) { 
 
    nodes.forEach((node: any) => {
      this.dropTargetIds.push(node.agendaId);
      this.nodeLookup[node.agendaId] = node;
      this.prepareDragDrop(node.subtopics);
      node.minutesList.forEach((min: any) => {
        this.dropTargetMinIds.push(min._id);
        this.minLookup[min._id] = node;
   

      })
 
  });

  }

  alertShown = false;
  dragMoved(event: any, main: boolean = false) {
 
    
    if(main) {
      if(!this.alertShown) {
        alert('Main agenda can not be moved !');
        this.alertShown = true;
        event.preventDefault();
      } 
      return;
    } else {
      this.alertShown = false;
      let e = this.document.elementFromPoint(event.pointerPosition.x,event.pointerPosition.y);
      
      if (!e) {
          this.clearDragInfo();
          return;
      }
      let container = e.classList.contains("node-item") ? e : e.closest(".node-item");
      
      if (!container) {
          this.clearDragInfo();
          return;
      }
      this.dropActionTodo = {
          targetId: container.getAttribute("data-id")
      };
      
      const targetRect = container.getBoundingClientRect();
      const oneThird = targetRect.height / 3;

      if (event.pointerPosition.y - targetRect.top < oneThird) {
          // before
          this.dropActionTodo["action"] = "before";
      } else if (event.pointerPosition.y - targetRect.top > 2 * oneThird) {
          // after
          this.dropActionTodo["action"] = "after";
      } else {
          // inside
          this.dropActionTodo["action"] = "inside";
      }
      
      this.showDragInfo();
    }
      
  }

  dragMinMoved(event: any) {
    let e = this.document.elementFromPoint(event.pointerPosition.x,event.pointerPosition.y);
    
    if (!e) {
        this.clearDragInfo();
        return;
    }
    let container = e.classList.contains("min-item") ? e : e.closest(".min-item");
    
    let agContainer = e.classList.contains("node-item") ? e : e.closest(".node-item");    

 

    
    if (!container) {
        this.clearDragInfo();
        const targetRect = agContainer?.getBoundingClientRect();
        const oneThird = targetRect!.height / 3;

        // const targetAgenda = agContainer!.getBoundingClientRect();
        // const oneThirdAgenda = targetAgenda.height / 3;

        if (event.pointerPosition.y - targetRect!.top < oneThird) {
            // before
            this.dropActionTodo = {
              targetId: agContainer!.getAttribute("data-id")
            };
            this.dropActionTodo["action"] = "before";
        } else if (event.pointerPosition.y - targetRect!.top > 2 * oneThird) {
            // after
            this.dropActionTodo = {
              targetId: agContainer!.getAttribute("data-id")
            };
            this.dropActionTodo["action"] = "after";
        } else {
            // inside
            this.dropActionTodo = {
              targetId: agContainer!.getAttribute("data-id")
            };
            this.dropActionTodo["action"] = "inside";
        }
        this.dropActionTodo.level = 'agenda';
    } else {
      const targetRect = container.getBoundingClientRect();
      const oneThird = targetRect.height / 3;

      // const targetAgenda = agContainer!.getBoundingClientRect();
      // const oneThirdAgenda = targetAgenda.height / 3;

      if (event.pointerPosition.y - targetRect.top < oneThird) {
          // before
          this.dropActionTodo = {
            targetId: container.getAttribute("data-id")
          };
          this.dropActionTodo["action"] = "before";
      } else if (event.pointerPosition.y - targetRect.top > 2 * oneThird) {
          // after
          this.dropActionTodo = {
            targetId: container.getAttribute("data-id")
          };
          this.dropActionTodo["action"] = "after";
      } else {
          // inside
          this.dropActionTodo = {
            targetId: container.getAttribute("data-id")
          };
          this.dropActionTodo["action"] = "inside";
      }
    }

    this.showDragInfo();
}

  drop(event: any) {
      if (!this.dropActionTodo) return;
 
      this.prepareDragDrop(this.meetingResponse.agendaList);
      const draggedItemId = event.item.data;
      const parentItemId = event.previousContainer.id;
      const targetListId = this.getParentNodeId(this.dropActionTodo.targetId, this.meetingResponse.agendaList, 'main');
      var pageIns = this;
      var agSeqMap: any = new Object();
      var agendaJSONReq: any;
   
      const draggedItem = this.nodeLookup[draggedItemId];
      const oldItemContainer = parentItemId != 'main' ? this.nodeLookup[parentItemId].subtopics : this.meetingResponse.groupedAgendaList![0].subtopics;
      const newContainer = targetListId != 'main' ? this.nodeLookup[targetListId].subtopics : this.meetingResponse.groupedAgendaList![0].subtopics;
      let i = oldItemContainer.findIndex((c: any) => c.agendaId === draggedItemId);
      if(i >= 0) {
        oldItemContainer.splice(i, 1);
      } else {
        oldItemContainer.splice(0, 1);
      }

      // if(draggedItem.entityType == "AG" || draggedItem.entityType == "SG") {

        draggedItem.parentAgendaId = newContainer.agendaId;

  

      let path;
      let parentId;
      let dropedParentAgendaId;
      switch (this.dropActionTodo.action) { 
          case 'before':
            const targetIndex1 = newContainer.findIndex((c: any) => c.agendaId == this.dropActionTodo.targetId);
            newContainer.splice(targetIndex1, 0, draggedItem);
       
            for(let i of newContainer) {
              if(i.agendaId == draggedItemId) {
                if(newContainer[0].agendaId == draggedItemId) {
                  i.path = newContainer[1].path;
                } else {
                  i.path = newContainer[0].path;
                }
              }
            }
            break;
          case 'after':
              const targetIndex = newContainer.findIndex((c: any) => c.agendaId == this.dropActionTodo.targetId);
              // if (this.dropActionTodo.action == 'before') {
              //     newContainer.splice(targetIndex, 0, draggedItem);
              // } else {
                  newContainer.splice(targetIndex + 1, 0, draggedItem);
             
                  for(let i of newContainer) {
                    if(i.agendaId == draggedItemId) {
                      if(newContainer[0].agendaId == draggedItemId) {
                        i.path = newContainer[1].path;
                      } else {
                        i.path = newContainer[0].path;
                      }
                    }
                  }
              // }
              break;

          case 'inside':
              this.nodeLookup[this.dropActionTodo.targetId].subtopics.push(draggedItem)
              this.nodeLookup[this.dropActionTodo.targetId].isExpanded = true;
              dropedParentAgendaId = +this.dropActionTodo.targetId
              for(let i of this.nodeLookup[this.dropActionTodo.targetId].subtopics) {
                i.path = this.nodeLookup[this.dropActionTodo.targetId].path + '.' + i.agendaId;
                i.parentAgendaId = this.nodeLookup[this.dropActionTodo.targetId].agendaId;
                parentId = i.parentAgendaId;
                path = i.path;
              }
              break;
      }
      this.agSeqMap = [];
      this.meetingResponse.groupedAgendaList?.forEach((agElem: any, agIndex: number) => {
        
        this.addAgendaIds(agElem, this.agSeqMap);
        
      })


      let parentAgendaId: any;
      for(let i of this.allAgendaWithSub) {
   
        
        if(i.subtopics && i.subtopics.some((a: any) => a.agendaId == draggedItemId)) {
          parentAgendaId = i.agenda;
        }
      }

      
      const obj = this.agSeqMap.reduce((acc: any, curr: any, index: any) => {
        acc[index + 1] = curr;  // Assign each element to a key starting from 1
        return acc;
      }, {});
      var agSeqList = JSON.stringify(obj);

      
      agendaJSONReq = { "meetingId": draggedItem.meetingId, "agSeqList": agSeqList, "parentAgendaId": parentAgendaId, "agendaId": draggedItemId};


      this.meetingService.updateAgendaSequence(JSON.stringify(agendaJSONReq)).subscribe(res => {
        
      });

      
      // this.meetingResponse.agendaList?.map((a: any) => {
      //   if(a.agendaId == draggedItemId) {
      
          
      //   }
      // })
    
 
      // this.commonService.updateAgenda(document.getElementById("meetAgendaId" + draggedItemId), null, 'B', path, parentId);
 
 
      // this.trackMeetingResponse();
      this.clearDragInfo(true)
  }

  agSeqMap: any = [];
  allAgendaWithSub: any = [{}];
  addAgendaIds(agElem: any, agSeqMap: number[]): void {
    // Add the current agenda ID to the sequence map
    this.agSeqMap.push(agElem.agendaId);
        
    // If there are subtopics, iterate over them recursively
    if (agElem.subtopics) {
      this.allAgendaWithSub.push({agenda: agElem.agendaId, subtopics: agElem.subtopics});
      for (let i of agElem.subtopics) {
        this.addAgendaIds(i, agSeqMap); // Recurse for each subtopic
      }
    }
  }

  dropMin(event: any) {
    if (!this.dropActionTodo) return;
 
      const draggedItemId = event.item.data;
      const parentItemId = event.previousContainer.id;
      if(this.meetingResponse.agendaList && this.dropActionTodo.targetId != null) {
        for(let item of this.meetingResponse.agendaList) {

          // const targetListId = this.getParentMinId(this.dropActionTodo.targetId, item.minutesList, item.agendaId);
          // const targetListId = event.previousContainer.id;
          const targetListId = this.dropActionTodo.targetId;

          
          //     '\nmoving\n[' + draggedItemId + '] from list [' + parentItemId + ']',
          //     '\n[' + this.dropActionTodo.action + ']\n[' + this.dropActionTodo.targetId + '] from list [' + targetListId + ']');
       
          // const draggedItem = this.minLookup[draggedItemId];
          this.prepareDragDrop(this.meetingResponse.agendaList);
          let draggedItem;
       
          // const oldItemContainer = parentItemId != item.agendaId ? this.minLookup[parentItemId] : item;
          const oldItemContainer = parentItemId;
          let newContainer;
          if(this.dropActionTodo.level == 'agenda') {
            newContainer = targetListId != 'main' ? this.nodeLookup[targetListId] : this.meetingResponse.agendaList[0];
          } else {
            newContainer = targetListId != item.agendaId ? this.minLookup[targetListId] : item;
          }
         for(let i of oldItemContainer.minutesList) {
            if(i._id && i._id == draggedItemId) {
              draggedItem = i;
         
            }
          }
          
          draggedItem.agendaId = newContainer.agendaId;

          // if(this.dropActionTodo.action = 'inside') {
            let i = oldItemContainer.minutesList.findIndex((c: any) => c._id === draggedItemId);
            oldItemContainer.minutesList.splice(i, 1);
          // }


          

          if(draggedItem.entityType == "MN" || draggedItem.entityType == "MD") {
            const reqJson={
              "agendaId" : newContainer.agendaId,
              
            }
       
            const minJson={
              "minutesId": draggedItemId
            }
  
            const saveUrl = this.commonService.getSaveUrl ("Y",draggedItem.entityType,minJson);
       
  
            this.commonService.saveMinutesAttributes({}, reqJson, saveUrl, "Y");

          } else if(draggedItem.entityType == "AI") {
            const taskId = {
              "taskId": draggedItemId
            }

            const taskRequestJson = {
              "taskId": draggedItem.taskId,
              "agendaId": newContainer.agendaId,
              "minutesId": draggedItem.taskId?.replace("T_", ''),
              "meetingId": draggedItem.meetingId
            }
       
            this.meetingService.saveTaskAgendaId(JSON.stringify(taskRequestJson), draggedItem.taskId).subscribe((res: any) => {
         
            })
          }
  
            var minSequenceMap: any = new Object();
            var agendaId='';
            // this.draggedObj.agendaId = this.meetingResponse.agendaList![0].agendaId;
            // this.meetingResponse.agendaList![0].minutesList!.forEach((agElem: any, agIndex: any) => {
            //     agendaId = agElem.agendaId;
            //     const minid = agElem._id;
            //     const seq = agIndex + 1;
            //     minSequenceMap[seq] = minid;
            // });
            // var minSeqList = JSON.stringify(minSequenceMap);
            // var jsonReq = { "meetingId": this.meetingResponse.meetingId, "minSequenceList": minSeqList, "agendaId": agendaId }
            const arr = newContainer.path.split('.').map(Number);
            const obj = arr.reduce((acc: any, curr: any, index: any) => {
              acc[index + 1] = curr;  // Assign each element to a key starting from 1
              return acc;
            }, {});
            var agSeqList = JSON.stringify(obj);
            var jsonReq = { "meetingId": this.meetingResponse.meetingId, "minSequenceList": agSeqList, "agendaId": newContainer.agendaId }
            this.meetingService.updateMinSequence(JSON.stringify(jsonReq)).subscribe(res => {
              const minutesResp = res.body;
            });

          
     
          if(this.dropActionTodo) {
            switch (this.dropActionTodo.action) {
              case 'before':
              case 'after':
                  const targetIndex = newContainer.minutesList.findIndex((c: any) => c._id === this.dropActionTodo.targetId);
                  if (this.dropActionTodo.action == 'before') {
                      newContainer.minutesList.splice(targetIndex, 0, draggedItem);
                  } else {
                      newContainer.minutesList.splice(targetIndex + 1, 0, draggedItem);
                  }
             
                  break;

              case 'inside':
                  // this.nodeLookup[this.dropActionTodo.targetId].subtopics.push(draggedItem)
                  // this.nodeLookup[this.dropActionTodo.targetId].isExpanded = true;
                  newContainer.minutesList.push(draggedItem);
                  break;
          }

          this.clearDragInfo(true)
          }
        }
   
      }
  }

  getParentNodeId(id: string, nodesToSearch: any, parentId: any): any {
      for (let node of nodesToSearch) {
          if (node.agendaId == id) return parentId;
          let ret = this.getParentNodeId(id, node.subtopics, node.agendaId);
          if (ret) return ret;
      }
      return null;
  }

  getParentMinId(id: string, nodesToSearch: any, parentId: any): any {
    for (let node of nodesToSearch) {
        if (nodesToSearch._id == id) return parentId;
        // let ret = this.getParentNodeId(id, node.subtopics, node.agendaId);
        
        // if (ret) return ret;
    }
    return null;
  }

  showDragInfo() {
      this.clearDragInfo();
      
      if (this.dropActionTodo !== null) {
        const element = this.document.getElementById("node-" + this.dropActionTodo.targetId);
        
        if (element) {
       
            element.classList.add("drop-" + this.dropActionTodo.action);
        } else {
            console.warn("Element not found: node-" + this.dropActionTodo.targetId);
        }
    }
  }
  clearDragInfo(dropped = false) { 
      if (dropped) {
          this.dropActionTodo = null;
      }
      this.document
          .querySelectorAll(".drop-before")
          .forEach(element => element.classList.remove("drop-before"));
      this.document
          .querySelectorAll(".drop-after")
          .forEach(element => element.classList.remove("drop-after"));
      this.document
          .querySelectorAll(".drop-inside")
          .forEach(element => element.classList.remove("drop-inside"));
  }


  trigger(){
    // document.getElementById('menu')?.requestFullscreen()
  }

  //UI Team changes
  @Input()
  instantMeetingStarted !: any


  //agenda task edit dialog

  editDialog() {
    //window.alert("edit dialog triggered")
    const dialogRef = this.dialog.open(AgendaTaskEditDialogComponent, {
      panelClass: ['animate__animated','animate__slideInLeft'],
                  disableClose: true,
                  position : {
                    left : "0%"
                  },
                 
                  maxHeight: "100vh",
                  width: "50%",
                  maxWidth : "100%",
                  height : "100vh"
    })
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if(size.matches){
        dialogRef.updateSize('70vw','100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if(size.matches){
        dialogRef.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        dialogRef.updateSize('100vw', '100vh');
      }
    });
    dialogRef.afterClosed().subscribe(() => {
      mediumDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
    })
  }

  //notes dialog

  openNotesDialog(e: any) {
    const dialogRef = this.dialog.open(AgendaNotesFieldComponent, {
      data: { e }, disableClose: true,
      panelClass: ['animate__animated','animate__slideInLeft'],
                  // disableClose: false,
                  position : {
                    left : "0%"
                  },
                  maxWidth: "100%",
                  maxHeight: "100vh",
                  width: "50%",
                  height : "100vh"
    });
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if(size.matches){
        dialogRef.updateSize('70vw','100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if(size.matches){
        dialogRef.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        dialogRef.updateSize('100vw', '100vh');
      }
    });
    dialogRef.afterClosed().subscribe(() => {
      mediumDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
    })
  }

  // agenda edit dialog

  agendaEditDialog(req: any) {

    const roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utilService.featureList.AGENDA,this.utilService.permissionType.MODIFY);
    
    if(!roleFlag){
      return;
    }
    const reqJSON = { "meetingId": req.meetingId, "agendaId": req.agendaId };
    this.meetingService.fetchAgendaWithMinutes(reqJSON).subscribe((data: any) => {
      const e = data.body;
      const agEditDialog = this.dialog.open(AgendaEditDialogComponent, {
        data: { "agenda":e ,"meetingres" :this.meetingResponse}, disableClose: true,
        panelClass: ['animate__animated','animate__slideInLeft'],
                  
                  position : {
                    left : "0%"
                  },
                  maxWidth:"100%",
                  maxHeight: "100vh",
                  width: "50%",
                  height : "100vh"
      });
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if(size.matches){
          agEditDialog.updateSize('70vw','100vh');
        }
      })
      const smallSubscription = this.isSmall.subscribe(size => {
        if(size.matches){
          agEditDialog.updateSize('100vw', '100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          agEditDialog.updateSize('100vw', '100vh');
        }
      });
      agEditDialog.afterClosed().subscribe((data:any)=>{
        if (data) {          
            // if (this.agList.agendaId === data.agendaId) {
            //   this.agList = { ...this.agList, ...data };
            // }
            this.meetingResponse.groupedAgendaList = this.hasId(this.meetingResponse.groupedAgendaList, data.agendaId, data.agendaTitle);
          this.cd.detectChanges();
              this.updateAgDuration($.event, data.agendaId, data.agendaDuration);
        }        
        mediumDialogSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
      });
    })
  }

  hasId(data: any, targetId: string, updatedTitle: any): any {
    return data.map((item: any) => {
      const updatedItem = { ...item };
 
      if (updatedItem.agendaId === targetId) {
        updatedItem.agendaTitle = updatedTitle;
      }
 
      if (updatedItem.subtopics && updatedItem.subtopics.length > 0) {
        updatedItem.subtopics = this.hasId(updatedItem.subtopics, targetId, updatedTitle);
      }
 
      return updatedItem;
    });
   
  }
  //agenda predefined dialog

  openPreDefinedDialog(e: any) {
    const dialogRef = this.dialog.open(PredefinedNotesFieldComponent, {
      data: { e }, disableClose: true,
      panelClass: ['animate__animated','animate__slideInLeft'],
                  // disableClose: false,
                  position : {
                    left : "0%"
                  },
                  maxWidth : "100%",
                  maxHeight: "100vh",
                  width: "50%",
                  height : "100vh"
    });
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if(size.matches){
        dialogRef.updateSize('70vw','100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if(size.matches){
        dialogRef.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        dialogRef.updateSize('100vw', '100vh');
      }
    });
    dialogRef.afterClosed().subscribe(() => {
      mediumDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
    })
  }

  getAttachCount(e: any) {
    const reqJSON = { "meetingId": e.meetingId, "agendaId": e.agendaId };
    
    this.meetingService.fetchAgendaWithMinutes(reqJSON).subscribe((data: any) => {
      this.agendaAttachResp = data.body;
      
      this.attachCount = false;
    });
  }


  //agenda confidential dialog
  openConfidentialDialog(e: any, m: any) {
    const attchDialog = this.dialog.open(AttachmentDialogComponent, {
      data: {
        e,
        m,
        "data" : this.contentEditableBool,
        "disaleAttachmentFileIcon":this.disaleAttachmentFileIcon
      },
      panelClass: ['animate__animated','animate__slideInLeft'],
                  disableClose: true,
                  position : {
                    left : "0%"
                  },
                  maxWidth : "100%",
                  maxHeight: "100vh",
                  width: "50%",
                  height : "100vh"
    })
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if(size.matches){
        attchDialog.updateSize('70vw','100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if(size.matches){
        attchDialog.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        attchDialog.updateSize('100vw', '100vh');
      }
    });
    attchDialog.afterClosed().subscribe((response: any) => {
      mediumDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
      const reqJSON = {
        "meetingId": e.meetingId,
        "agendaId": e.agendaId
      };
       this.meetingService.fetchAgendaWithMinutes(reqJSON).subscribe((data: any) => {
        this.responsevalue = data
        this.editCollabData=<MinutesCollabDetails>{};
        
        if (data != undefined) {
         const agendaList = this.meetingResponse.agendaList;
         if (agendaList != null) {
           agendaList.forEach((ag: any,agIndex:any) => {
             if(ag.agendaId==e.agendaId){
              ag.attachmentTotalCnt=data.body.attachmentTotalCnt;
              this.editCollabData.elementId=e.agendaId;
              this.editCollabData.collabType='AGATTACH';
              this.editCollabData.agElemPosition=agIndex;
              this.editCollabData.attachmentTotalCnt=ag.attachmentTotalCnt;
              const sentUserName = localStorage.getItem("userName");
              if(sentUserName!=null && sentUserName!=undefined){
                this.editCollabData.sentByUserName=sentUserName;
              }
              this.editCollabData.userId=localStorage.getItem("userId")
              this.editCollabData.meetingId=this.meetingResponse.meetingId;
              if(this.meetingResponse.meetingType!= undefined && this.meetingResponse.meetingType!=null&& this.meetingResponse.meetingType!=""){
                this.editCollabData.meetTypeVal=this.meetingResponse.meetingType;
              }
                
              this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId,this.editCollabData).subscribe((data) => {
              });
             }
           });
         }
        }
      });

    })
    ////consolee.log("value of e",e,"value of m",m)
  }

  //agenda link dialog

  addNewLink(entityId: any, meetingId: any) {
    const addLinkDialog = this.dialog.open(AddLinkDialogComponent, {
      data: { entityId, meetingId, "entityType": "AG", "attachmentMode": "LI","data" : this.contentEditableBool,"disaleAttachmentFileIcon":this.disaleAttachmentFileIcon },
      panelClass: ['animate__animated','animate__slideInLeft'],
                  disableClose: false,
                  position : {
                    left : "0%"
                  },
                  maxWidth : "100%",
                  maxHeight: "100vh",
                  width: "50%",
                  height : "100vh"
    })
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if(size.matches){
        addLinkDialog.updateSize('70vw','100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if(size.matches){
        addLinkDialog.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        addLinkDialog.updateSize('100vw', '100vh');
      }
    });
    addLinkDialog.afterClosed().subscribe((response: any) => {
      mediumDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
      const reqJSON = {
        "meetingId": meetingId,
        "agendaId": entityId
      };
      
      this.meetingService.fetchAgendaWithMinutes(reqJSON).subscribe((data: any) => {
        this.responsevalue = data
        this.editCollabData=<MinutesCollabDetails>{};
        
        if (data != undefined) {
         const agendaList = this.meetingResponse.agendaList;
         if (agendaList != null) {
           agendaList.forEach((ag: any,agIndex:any) => {
             if(ag.agendaId == entityId){
              ag.attachmentTotalCnt=data.body.attachmentTotalCnt;
              this.editCollabData.elementId=ag.agendaId;
              this.editCollabData.collabType='AGATTACH';
              this.editCollabData.agElemPosition=agIndex;
              this.editCollabData.attachmentTotalCnt=ag.attachmentTotalCnt;
              const sentUserName = localStorage.getItem("userName");
              if(sentUserName!=null && sentUserName!=undefined){
                this.editCollabData.sentByUserName=sentUserName;
              }
              this.editCollabData.userId=localStorage.getItem("userId")
              this.editCollabData.meetingId=this.meetingResponse.meetingId;
              if(this.meetingResponse.meetingType!= undefined && this.meetingResponse.meetingType!=null&& this.meetingResponse.meetingType!=""){
                this.editCollabData.meetTypeVal=this.meetingResponse.meetingType;
              }
              this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId,this.editCollabData).subscribe((data) => {
              });
             }
           });
         }
        }
      });

    })
  }
  ngOnDestroy(){
   
      for (const instance in CKEDITOR.instances) {
        CKEDITOR.instances[instance].destroy();
      }
  this.disposeDurationPopup('popover');

  }

  descriptionVissible = false;

  @Input()
  deviceXs!: boolean;

  @Input()
  deviceSm!: boolean;

  @Input()
  deviceMd!: boolean;

  @Input()
  deviceLg!: boolean;

  @Input()
  deviceXl!: boolean;
  @Output() latestMeetingResponse: any = new EventEmitter();
  spanChecker = false

  changeSpanChecker() {
    this.spanChecker = !this.spanChecker;
  }

  @HostListener('document:click', ['$event'])
  hideDatepickerOutsideClick(e: any) {
    //var container = $(".meetingCurDate");
    const container1 = $("#editable");
    const container2 = $("#ui-datepicker-div");
    //var container3 = $("#datecls");
    const container4 = $(".ui-datepicker-prev");
    const container5 = $(".ui-datepicker-next");
    const container6 = $(".ui-icon");
    // //
    if (!container1.is(e.target) && container1.has(e.target).length === 0 && !container2.is(e.target) && container2.has(e.target).length === 0 && !container4.is(e.target) && container4.has(e.target).length === 0 && !container5.is(e.target) && container5.has(e.target).length === 0 && !container6.is(e.target) && container6.has(e.target).length === 0 && !$(e.target).hasClass("ui-icon-circle-triangle-e") && !$(e.target).hasClass("ui-icon-circle-triangle-w") && !$(e.target).hasClass("ui-corner-all") && !$(e.target).hasClass("hasDatepicker")) {
      $(".ui-datepicker").hide();
    }
    // if ($(e.target).parents('.popover').length ===0 &&  !$(e.target).is($('.agDurCls')) && $(e.target).parents('.agDurCls').length ===0) {
    //     $('.agDurCls').popover('hide');
    // }

  }


  openDescription() {
    this.descriptionVissible = !this.descriptionVissible
  }

  dropMinutesBetweenAgenda(event: CdkDragDrop<string[]>, minIndex : any) {
    if (event.previousContainer === event.container) {
    moveItemInArray(this.meetingResponse.agendaList![minIndex].minutesList!, event.previousIndex, event.currentIndex);

    var minSequenceMap: any = new Object();
    var agendaId='';
    this.meetingResponse.agendaList![minIndex].minutesList!.forEach((agElem: any, agIndex: any) => {
        agendaId = agElem.agendaId;
        const minid = agElem._id;
        const seq = agIndex + 1;
        minSequenceMap[seq] = minid;
      
    });
    var minSeqList = JSON.stringify(minSequenceMap);
    var jsonReq = { "meetingId": this.meetingResponse.meetingId, "minSequenceList": minSeqList, "agendaId": agendaId }
    this.meetingService.updateMinSequence(JSON.stringify(jsonReq)).subscribe(res => {
      const minutesResp = res.body;
    });
    // moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      const data={}
      var agendaId='';
      transferArrayItem(
        this.meetingResponse.agendaList![this.dragPositionIndex].minutesList!,
        this.meetingResponse.agendaList![minIndex].minutesList!,
        event.previousIndex,
        event.currentIndex
      )
        if(this.draggedObj.entityType=='MN' ||this.draggedObj.entityType=='MD'){
        const reqJson={
          "agendaId" : this.meetingResponse.agendaList![minIndex].agendaId,
        }
        const minJson={
          "minutesId": this.draggedId
        }
       
        const saveUrl = this.commonService.getSaveUrl ("Y",this.draggedEntityType,minJson);
        this.commonService.saveMinutesAttributes(data, reqJson, saveUrl, "Y")  ;
       
       
      } else if(this.draggedObj.entityType=='AI'){
          let assignedTo :any
          const taskId={
            "taskId" : this.draggedId
          }
           const taskReqJson={
             "taskId": this.draggedObj.taskId,
             "agendaId": this.meetingResponse.agendaList![minIndex].agendaId ,
             "minutesId" : this.draggedObj.taskId?.replace("T_", ""),  
             "meetingId" : this.draggedObj.meetingId          
           }
           this.meetingService.saveTaskAgendaId(JSON.stringify(taskReqJson),this.draggedObj.taskId).subscribe(res => {

           });
          
      }
      var minSequenceMap: any = new Object();
      var agendaId='';
      this.draggedObj.agendaId = this.meetingResponse.agendaList![minIndex].agendaId;
      this.meetingResponse.agendaList![minIndex].minutesList!.forEach((agElem: any, agIndex: any) => {
          agendaId = agElem.agendaId;
          const minid = agElem._id;
          const seq = agIndex + 1;
          minSequenceMap[seq] = minid;
      });
      var minSeqList = JSON.stringify(minSequenceMap);
      var jsonReq = { "meetingId": this.meetingResponse.meetingId, "minSequenceList": minSeqList, "agendaId": agendaId }
      this.meetingService.updateMinSequence(JSON.stringify(jsonReq)).subscribe(res => {
        const minutesResp = res.body;
      });
    }
  }

  triggerDragged(index : any, obj : any){
    this.dragPositionIndex = index
    this.draggedObj= obj;
    this.draggedId = obj['_id'];
    this.draggedEntityType =obj['entityType'];
  }

  currentDuration(el:any){
    this.currentDurationVal = el;
  }


  dropCard(event: CdkDragDrop<any>) { 
    const agSeqMap: any = new Object();
    let agendaJSONReq:any;
    moveItemInArray(this.meetingResponse.agendaList!, event.previousIndex, event.currentIndex);
    this.meetingResponse.agendaList?.forEach((agElem: any, agIndex: any) => {
      let seq=0;
      seq = agIndex + 1;
      agSeqMap[Number(seq)] = Number(agElem.agendaId);
      const agSeqList = JSON.stringify(agSeqMap);
      agendaJSONReq = { "meetingId": this.meetingResponse.meetingId, "agSeqList": agSeqList};
    });
    this.meetingService.updateAgendaSequence(JSON.stringify(agendaJSONReq)).subscribe(res => {
    });
  }

  printMsg() {
    alert("ag" + this.meetingResponse.agendaList)
  }

  ngAfterContentInit(): void {
    //this.commonService.shareDatatoService(this.meetingResponse);
    // this.printMsg();
  }

  openDurationPopover(agList: any, event: any) {
    
    let curElem = event.target;
    const agendaId = agList.agendaId;
    if ($(curElem).hasClass("agDurLabelCls")) {
      curElem = $(curElem).parent(".agDurCls")[0];
    }
    if (curElem != null && curElem != undefined && $(curElem).hasClass("agDurCls")) {
      const pageIns = this;
      const tempHtml = '<div class="row agDurPopupCls" id="agPopup' + agList.agendaId + '">' +
        '<div class="col-6">' +
        '<input type="text" id="agPopOverDur" class="agPopOverDurInputCls" maxlength="3" value="10">' +
        '</div>' +
        '<div class="col-6">' +
        '<button id="savePopupBtn' + agList.agendaId + '" class="btn btn-outline-primary" type="button" data-bs-toggle="popover"><mat-icon>check</mat-icon></button>' +
        '</div>' +
        '</div>';
       const popBody = document.getElementsByClassName('popover-body');
       console.log(popBody,'body element');
       
       if(popBody.length > 0){
          this.hideDurationPopup('popover');
       }

         if (!$(".popover").find("#agPopover" + agendaId).is(":visible")) {
        
        // $(".popover").find("#agPopover" + agendaId).css("display", "block");
        $("#agPopover" + agendaId).css("display", "block")
      }else {

      }

      const ins = Popover.getOrCreateInstance(curElem, {
        title: '<h4 class="custom-title" style = "margin:0px;font-size:0.9rem;font-weight:500"><i class="bi-info-circle-fill"></i> Duration</h4>',
        content: $("#agPopover" + agendaId)[0],
        html: true,
        sanitize: false,
        //trigger: 'focus'
      });
      
      ins.toggle();
      
      curElem.addEventListener('shown.bs.popover', function (elem: any) {
        const curAgId = $(curElem).parents(".agendaTitleCls").attr("agid");
        const curagTime = pageIns.utilService.nvl($("#agendaMainId" + curAgId)?.attr("agendatime")?.trim());
        ////consolee.log(curAgId+"inside show>>>"+curagTime);
        $("#agPopOverDur" + curAgId).val(curagTime);
        $("#agPopOverDur" + curAgId).focus();
      })
      
     
      
    }
  }
  updateAgDuration(event: any, agendaId: any, agendaDuration:any) {
    new Promise((reject: any, resolve: any) => {      
      const agTime: any = agendaDuration == '' ? $("#agPopOverDur" + agendaId)?.val() : agendaDuration;
      
      if (this.utilService.nvl(agTime) != "") {
      this.commonService.checkAgendaDurationExceed(agTime, agendaId).then((resp:any)=>{
        

        
        if(resp > this.currentDurationVal){
          this.latestMeetingResponse.emit(this.meetingResponse)
        }
        
        
        if(resp!=undefined && resp !=null && resp != ""){
        
          
          document.getElementById("agendaMainId" + agendaId)?.setAttribute("agendatime", resp);
          $("#meetAgendaId" + agendaId).find(".agDurCls").html('<span class="agDurLabelCls">[ </span>' + resp + '<span class="agDurLabelCls"> Minutes ]</span>');
        
        //$('.agDurCls').popover('hide');
      } else {
        
        //$("#meetAgendaId"+agendaId).find(".agDurCls").popover('dispose');
        $("#meetAgendaId" + agendaId).find(".agDurCls").remove();
        document.getElementById("agendaMainId" + agendaId)?.setAttribute("agendatime", "");
      }
      this.hideDurationPopup("popover");
      this.commonService.updateAgenda(document.getElementById("meetAgendaId" + agendaId), null, 'B');
      resolve(true);
      });

    }else{
      
    }
    }) .catch(error => {
      this.hideDurationPopup("popover");
 
    });
  }

  trackByMin(index: number, el: any): number {
    //this.commonMinService?.initializeMinSec(el._id);
    
    return el._id;
  }

  hideDurationPopup(popoverCls: any) {
 
    Array.from(document.querySelectorAll("." + popoverCls)).forEach(popoverNode => {
      // //
      const ins = Popover.getInstance(popoverNode);
      if (ins != null && ins != undefined) {
        ins.hide();
      }
      const node = popoverNode as HTMLElement;
      node.style.display ='none'
    });
  }
  disposeDurationPopup(popoverCls: any) {
 
    Array.from(document.querySelectorAll("." + popoverCls)).forEach(popoverNode => {
      // //
      const ins = Popover.getInstance(popoverNode);
      if (ins != null && ins != undefined) {
        ins.dispose();
      }
    });
  }

  trackMeetingResponse() {
    this.latestMeetingResponse.emit(this.meetingResponse);
    this.subAgendaEventEmitter.emit(this.meetingResponse);

  }
  isDisplayNote(minElem: any): boolean {
    
    return true;
  }

  increementCounter(id: any) {
     const value = $('#agPopOverDur' + id).val()
    let newincCounter;
    if (value != undefined) {
      newincCounter = Number(value) + 10
      $('#agPopOverDur' + id).val(newincCounter)

    }
  }

  decreementCounter(id: any) {
    const value = $('#agPopOverDur' + id).val()
    let newdecCounter;
    if (value != undefined) {
      newdecCounter = Number(value) - 10
      $('#agPopOverDur' + id).val(newdecCounter)
    }
  }

  ngDoCheck(){
    if(this.timerTrackerArray.length != 0){
      for(var i = 0; i < this.timerTrackerArray.length; i ++){
        const doubleCheck = (<HTMLElement>document.getElementById('timer'+this.timerTrackerArray[i]));
        if(doubleCheck!=null){
          doubleCheck.hidden = false;
        }
        
      }
    }
    if(!this.contentEditableBool){
      
      for(var i = 0; i < document.getElementsByClassName('agendaEdit').length; i ++){
        document.getElementsByClassName('agendaEdit')[i].setAttribute('contenteditable','false')
      }
    }
  }

  ngOnChanges(events : any){
   
    // meetAgendaId5473
    $('html').on("click", function(event){
    
      if (event.target.className != "agDurLabelCls" && event.target.className != 'popover-header' && event.target.className != 'popover-body' && event.target.className != 'agPopOverDurInputCls' && event.target.className != 'custom-title' && event.target.className != 'ng-star-inserted' && event.target.className != 'agPopOverDurInputCls justify-content-between col-md-12 d-flex' && event.target.className != 'form-control text-center bs-timepicker-field' && event.target.className != 'arrow-one d-flex justify-content-center' && event.target.className != 'arrow-two d-flex justify-content-center' && event.target.className != 'mat-icon notranslate duration-top-buttons material-icons mat-icon-no-color' && event.target.className != 'agDurCls') {
        Array.from(document.querySelectorAll(".agDurCls")).forEach(popoverNode => {
          // //
          const ins = Popover.getInstance(popoverNode);
          if (ins != null && ins != undefined) {
            ins.hide();
          }
        });
      }
    });
    
  }
  createEmptyAgenda(event:any){
    
    const roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utilService.featureList.AGENDA,this.utilService.permissionType.MODIFY);
          
          if(!roleFlag){
            return
          }
    const newAg='AG'
    this.commonService.trackAgendaEventOnClick(event,newAg);
    // this.trackMeetingResponse();
  }

  createEmptyNote(event:any){
   
   const roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utilService.featureList.NOTES,this.utilService.permissionType.MODIFY);
          
          if(!roleFlag){
            return
          }
    const entityType="/nn";
    this.commonService.trackAgendaEventOnClick(event,entityType);

  }

  createEmptyTask(event:any){
    
    const roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utilService.featureList.TASK,this.utilService.permissionType.MODIFY);
          
          if(!roleFlag){
            return
          }
    const entityType="/tt";
    this.commonService.trackAgendaEventOnClick(event,entityType);

  }

  createEmptyDecision(event:any){
    
    const roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utilService.featureList.NOTES,this.utilService.permissionType.MODIFY);
          
          if(!roleFlag){
            return
          }
    const entityType="/dd";
    this.commonService.trackAgendaEventOnClick(event,entityType);

  }

  enableOrDisableAgendaEdit(e:any){

    
    


    if(e == 'Y' && this.meetingResponse.commonMomStatusCode == 'A'){
      this.previewsAgendaEditIcons = true;
    }else{
      this.previewsAgendaEditIcons = false;
    }

    
  }

  getMinComStatusCode(){
 
    if(this.meetingResponse.commonMomStatusCode == 'A'){
      this.disaleAttachmentFileIcon = true;
    }else{
      this.disaleAttachmentFileIcon = false;
    }
  }

  createEmpty(event:any){
    var selectTextAsNote = (event.altKey  &&  event.keyCode == 78);//(ALT+N)
    var selectTextAsDecision = (event.altKey  &&  event.keyCode == 68);//(ALT+D)
    var selectTextAsTask = (event.altKey  &&  event.keyCode == 84);//(ALT+T)
    var createAgenda = (event.altKey  &&  event.keyCode == 71)
    if(selectTextAsNote){
      this.createEmptyNote(event);
    }
    else if(selectTextAsTask){
      this.createEmptyTask(event);
    }
    else if(selectTextAsDecision){
      this.createEmptyDecision(event)
    }
    else if(createAgenda){
      this.createEmptyAgenda(event)
    }   

  }
  onUpdateTimerTracker(updatedArray: number[]) {
    this.timerTrackerArray = updatedArray;
  }
 /* getTaskUpdateStatus(event : any){
    this.isTaskUpdated.emit(event);
  }*/
}
